// Layers
import PageLayer from "@Layouts/views/PageLayer";
import ServiceOperationsLayer from "@DataPages/components/ServiceOperations/ServiceOperationsLayer";

// Icons
import ROIcon from "@/assets/icons/dataPages/repairOrders/RO.svg";

export default function ServiceOperations() {
	return (
		<PageLayer title={"Service Operations"} icon={ROIcon}>
			<ServiceOperationsLayer />
		</PageLayer>
	);
}
